// The support inbox. Bound in Cloudflare Email Routing to the Email Worker
// in infra/cloudflare/support-email-worker, which opens a thread in the
// admin support queue.
//
// On algonavis.com, not the product hostname: Email Routing owns the MX for
// the apex, and that is what the Worker is wired to. Renaming the product
// did not move the mailbox, and moving it would mean re-pointing MX and
// re-binding the routing rule by hand.
export const SUPPORT_EMAIL = "support@algonavis.com";
